import { BRAND_COLORS } from "./brandAssets";

export const SHARE_CARD_TIER = {
  TEAL: "teal",
  GOLD: "gold",
};

const TEAL = BRAND_COLORS.cyan;

export const SHARE_CARD_THEMES = {
  [SHARE_CARD_TIER.TEAL]: {
    id: SHARE_CARD_TIER.TEAL,
    accent: TEAL,
    grade: "#b8f4f3",
    frame: "rgba(132, 230, 229, 0.38)",
    frameSoft: "rgba(132, 230, 229, 0.2)",
    tagStroke: "rgba(132, 230, 229, 0.55)",
    foilStops: [
      [0, "#e8fffe"],
      [0.26, TEAL],
      [0.52, "#3db8b6"],
      [0.7, "#b8f4f3"],
      [1, "#145e5c"],
    ],
    ringStops: [
      [0, "#145e5c"],
      [0.2, "#b8f4f3"],
      [0.4, "#3db8b6"],
      [0.6, "#e8fffe"],
      [0.8, "#1a6b6a"],
      [1, "#145e5c"],
    ],
    ringHighlight: "rgba(232, 255, 254, 0.55)",
    ringInner: "rgba(232, 255, 254, 0.22)",
    wash: "rgba(232, 255, 254, 0.28)",
    washMid: "rgba(132, 230, 229, 0.1)",
    glare: "rgba(232, 255, 254, 0.45)",
    glareMid: "rgba(132, 230, 229, 0.14)",
    edge: "#3db8b6",
  },
  [SHARE_CARD_TIER.GOLD]: {
    id: SHARE_CARD_TIER.GOLD,
    accent: "#d4a017",
    grade: "#f0cf76",
    frame: "rgba(214, 176, 90, 0.4)",
    frameSoft: "rgba(214, 176, 90, 0.2)",
    tagStroke: "rgba(214, 176, 90, 0.55)",
    foilStops: [
      [0, "#fff4c9"],
      [0.28, "#f0cf76"],
      [0.55, "#c9971f"],
      [0.74, "#f6dd8e"],
      [1, "#9a7317"],
    ],
    ringStops: [
      [0, "#7c5a12"],
      [0.2, "#f6dd8e"],
      [0.4, "#c9971f"],
      [0.6, "#fff4c9"],
      [0.8, "#9a7317"],
      [1, "#7c5a12"],
    ],
    ringHighlight: "rgba(255, 246, 208, 0.55)",
    ringInner: "rgba(255, 245, 205, 0.22)",
    wash: "rgba(255, 240, 200, 0.42)",
    washMid: "rgba(255, 220, 150, 0.16)",
    glare: "rgba(255, 240, 200, 0.5)",
    glareMid: "rgba(255, 220, 150, 0.16)",
    edge: "#dca94a",
  },
};

/**
 * First matching rule wins. Daily and regular games stay teal;
 * gold is reserved for a perfect board.
 */
const TIER_RULES = [
  {
    id: SHARE_CARD_TIER.GOLD,
    when: ({ correct, total }) => Number(total) > 0 && Number(correct) === Number(total),
  },
];

export function resolveShareCardTier({ mode, correct, total, tier } = {}) {
  if (tier && SHARE_CARD_THEMES[tier]) return tier;
  const match = TIER_RULES.find((rule) => rule.when({ mode, correct, total }));
  return match?.id || SHARE_CARD_TIER.TEAL;
}

export function resolveShareCardTag({ mode, tier } = {}) {
  const id = tier || SHARE_CARD_TIER.TEAL;
  if (id === SHARE_CARD_TIER.GOLD) return "FLAWLESS";
  if (mode === "daily") return "DAILY";
  if (mode === "custom") return "CUSTOM";
  return "TRIVIA";
}

export function getShareCardTheme(input) {
  const id = typeof input === "string" ? input : resolveShareCardTier(input);
  return SHARE_CARD_THEMES[id] || SHARE_CARD_THEMES[SHARE_CARD_TIER.TEAL];
}

export function createThemeFoil(ctx, theme, x0, y0, x1, y1) {
  const gradient = ctx.createLinearGradient(x0, y0, x1, y1);
  theme.foilStops.forEach(([stop, color]) => gradient.addColorStop(stop, color));
  return gradient;
}
